/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { LocationItemLocationItemConditionFromJSON, LocationItemLocationItemConditionToJSON, } from './LocationItemLocationItemCondition';
import { LocationItemLocationItemTypeFromJSON, LocationItemLocationItemTypeToJSON, } from './LocationItemLocationItemType';
export function ApiLocationItemSimplifiedFromJSON(json) {
    return ApiLocationItemSimplifiedFromJSONTyped(json, false);
}
export function ApiLocationItemSimplifiedFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'condition': !exists(json, 'condition') ? undefined : LocationItemLocationItemConditionFromJSON(json['condition']),
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'key': !exists(json, 'key') ? undefined : json['key'],
        'locationId': !exists(json, 'locationId') ? undefined : json['locationId'],
        'pageTaggerId': !exists(json, 'pageTaggerId') ? undefined : json['pageTaggerId'],
        'type': !exists(json, 'type') ? undefined : LocationItemLocationItemTypeFromJSON(json['type']),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}
export function ApiLocationItemSimplifiedToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'condition': LocationItemLocationItemConditionToJSON(value.condition),
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'id': value.id,
        'key': value.key,
        'locationId': value.locationId,
        'pageTaggerId': value.pageTaggerId,
        'type': LocationItemLocationItemTypeToJSON(value.type),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'value': value.value,
    };
}
